<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>{{data.x}}</div>
</template>

<script>
import sleep from 'utils/sleep'

export default {
  data () {
    return {
      ready: false,
      data: null,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        // load data, call async function here.
        let [one, two] = await Promise.all([
          sleep(100, 1), // 100ms后返回1
          sleep(200, 2), // 200ms后返回2
        ])
        this.data = {x: one + two}
        this.ready = true
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/Sample.vue